<!--
 * @Description: 常规工作 班主任代选 详情
 * @Author: PF
 * @Date: 2023-06-13 16:55:12
 * @LastEditors: PF
 * @LastEditTime: 2023-06-16 13:26:44
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.xqmc}}
        </el-descriptions-item>
        <el-descriptions-item label="学号" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.xh}}
        </el-descriptions-item>
        <el-descriptions-item label="学生姓名" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.xm}}
        </el-descriptions-item>
        <el-descriptions-item label="合计学分" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.hjxf}}
        </el-descriptions-item>
        <el-descriptions-item label="选课方式" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in xkfsData.list" :key="index">
            <span v-if="item.value === ruleForm.xkfs">{{ item.name }}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="报名时间" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.bmsj}}
        </el-descriptions-item>
        <el-descriptions-item label="限定选修课" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in ruleForm.xdxxks" :key="index">
            <span v-if="index > 0">、</span>
            {{ item.kcmc }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="任意选修课" label-align="right" align="left" width="120px" span="2">
          <span v-for="(item, index) in ruleForm.ryxxks" :key="index">
            <span v-if="index > 0">、</span>
            {{ item.kcmc }}
          </span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import {
  actionPost,
  closeWindow
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getxkfs } from '@/utils/meiju'
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail', 'ReturnData'])
const ruleForm = ref({ xsids: [], xdxxks: [], ryxxks: [] })
const row = ref()

const xkfsData = ref()
const initInfo = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaowuxuanxiukexueshengxuanxiuke/' + row.value.id,
    data: { menuId: sessionStorage.getItem('menuId') }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      ruleForm.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      xkfsData.value = getxkfs()
      row.value = props.row
      ruleForm.value.id = props.row.id
      ruleForm.value.xqid = props.row.xqid
      ruleForm.value.xsid = props.row.xsid
      initInfo()
    }
  },
  { deep: true, immediate: true }
)
</script>
